import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'faqScopeType'
})
export class FaqScopeTypePipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 1:
        return 'Web App';
      case 2:
        return 'Admin App';
      default:
        return 'Unknown';
    }
  }
}
